<div appDropzone (hovered)="toggleHover($event)" (dropped)="onDrop($event)">
  <ng-content></ng-content>
</div>
